import { render, staticRenderFns } from "./VoyageInfoPanel.vue?vue&type=template&id=6180e7e6&scoped=true"
import script from "./VoyageInfoPanel.vue?vue&type=script&lang=js"
export * from "./VoyageInfoPanel.vue?vue&type=script&lang=js"
import style0 from "./VoyageInfoPanel.vue?vue&type=style&index=0&id=6180e7e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6180e7e6",
  null
  
)

export default component.exports